export default {
  login: {
    login: '登入',
    loginSubtitle: '登入你的帳號',
    username: '帳號',
    password: '密碼',
    forgetPassword: '忘記密碼?'
  },
  forgetPassword: {
    forgetPassword: '忘記密碼',
    forgetPasswordSubtitle: '輸入你的用戶名重設密碼',
    username: '用戶名稱',
    backToLogin: '回去登入',
    success: '你的密碼已被重設 新密碼會送到你的註冊電郵'
  }
}


// WEBPACK FOOTER //
// ./src/Auth/langs/zh_hk/index.js